<template lang="pug">
  div.auth
    div.layout-auth
      div.auth-header
        div.container
          img.img-fluid(src='https://www.sta.co.uk/wp-content/themes/sta/assets/images/desktop_branding_logo.png')
          div.system-text Digital Awards System
      div.auth-content
        div.container
          router-view
    div.auth-footer
      div.copyright-text The Swimming Teachers Association Limited, company registered in England (No 01272519) and a registered charity (No. 1051631 in England and Wales and SC041988 in Scotland) whose objective is: "The preservation of human life by the teaching of swimming, lifesaving and survival techniques."
      a.website-link(href="https://www.sta.co.uk") https://www.sta.co.uk
</template>

<script>
export default {
  data: () => ({
    logoUrl: process.env.VUE_APP_LOGO_URL
  })
}
</script>
